// import React from 'react';
//  import BreadCrumb from '../../../../Components/Utils/Breadcrumbs';
// import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';
// import { Link, useLocation, useParams } from 'react-router-dom';
// import Dashboard from '../../../../Components/Icons/Dasboard';
// import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
// import { NormalHeading } from '../../../../Components/Utils/Heading';
// import ApprovalComponent from '../../../../Components/Utils/approvalComponent';
// import capitalizeFirstLetter from '../../../../Components/Utils/Funcs';
// import { GetAccess, GetRole } from '../../../../Components/Utils/roles';

import { Link, useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
import { GetAccess, GetRole } from "../../../../../../Components/Utils/roles";
import { BackButton, EditButton } from "../../../../../../Components/Utils/Buttons";
import capitalizeFirstLetter from "../../../../../../Components/Utils/Funcs";
import ApprovalComponent from "../../../../../../Components/Utils/approvalComponent";
import { useEffect, useState } from "react";
import axiosInstance from "../../../../../../Services/axiosCommon";

const ViewRequest = () => {
  const { requestViewId,officeId,projeCtId,requestEditId ,requestId} = useParams();
    const [revData,setRevData] = useState([])
  
  const location = useLocation();
  const data = location.state.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  
  useEffect(() => {
    if(requestViewId)getRevData(requestViewId)
    // getPDF(prViewId)
  },[requestViewId])

  function getRevData(id){
    axiosInstance.get(`/PR/pr-products/${requestViewId}`).then(res=>{
      console.log("ree",res?.data?.data);
      if(res?.data?.data)setRevData(res?.data?.data)
      
    }).catch(err=>{
      console.log("err", err);
    })
  }

    const id = requestViewId; 
    const getUrl = `/requests/get-status`;
    const putUrl = `/requests/edit-status`; 
    const statusUrl = '/requests/all-status';

    const EditAccess = "requests_edit"

  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-end ">
      {/* <Breadcrumb
         items={
          [
            { name: "Store",
            // link: `/main/${officeId}/store/requests` 
          },
          {
            name: "Request",
            link: `/project/store/request/${officeId}/${projeCtId}`
          },
          {
            name: "View Request"
          }]
         }
        /> */}
        <div className=" flex gap-2">
          <Link to={`/project/store/request/${officeId}/${projeCtId}`} state={{currentPage:pageIndex,searchQuery:searchQuery!=""?searchQuery:""}}><BackButton link={true}/></Link>
          {data?.editable === false ? (
            <>
            {GetRole() && (
          <Link to={`/project/store/request/${officeId}/${projeCtId}/edit/${requestViewId}`} state={{data: data, from:`/project/store/request/${officeId}/${projeCtId}/view/${requestViewId}`}}><EditButton height='8'/></Link>
          )}
          </>
        ) : (
        <>
        {GetAccess(EditAccess) && (
          <Link to={`/project/store/request/${officeId}/${projeCtId}/edit/${requestViewId}`} state={{data: data, from:`/project/store/request/${officeId}/${projeCtId}/view/${requestViewId}`}}><EditButton height='8'/></Link>
          )}
          </>
          )
        }
        </div>
      </div>
      <div className="w-full mx-auto h-[calc(100vh-127px)]  rounded-md md:overflow-hidden p-2   md:flex gap-2 text-[#111537]">
        <div className="md:w-[70%]  bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden ">
        <div className="w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg flex justify-between items-center  z-10 mt-4">  
       

      <div className="grid items-center px-2">
      <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-[90%]">
            <p className="">{data?.itemName || 'None'}</p>
            {/* <p className=""> : {data?.description || 'None'}</p> */}
            </div>
            <div className="flex gap-4">
           
         <p className='text-xs text-[#111537]'>Request by : {data?.preparedByName  ? capitalizeFirstLetter(data?.preparedByName) : 'None'}</p>
         </div>
         </div>
         {/* <p className="bg-[#579BB1] text-white items-center rounded-md text-xs p-[2px]"> {data.status || 'None'}</p> */}
         <div className="border rounded-md mr-3 border-textColor-main text-xs inline-flex w-auto  flex-shrink-0  justify-center">
            <p className="  bg-white  text-black  p-1 rounded-l-md  ">
              Status  </p><p className="bg-textColor-main text-white p-1 items-center rounded-r-md"> {data.status || 'None'}</p>
             
              </div>
         
      
              </div>
              {/* <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8"> */}

        <div className='w-[98%] flex flex-wrap px-2 border border-gary mt-4 mx-2 rounded-lg '>
          <div className="w-full sm:grid grid-cols-2 gap-x-8 py-1">
           
           
          {/* <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Agent ID</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.requestId || '-'}</p>
                  </div> */}
                  {/* <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Request For</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.requestFor || '-'}</p>
                  </div> */}
                  {/* <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Purpose</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.purpose || '-'}</p>
                  </div> */}
                  {/* <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Item</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.itemName || '-'}</p>
                  </div> */}
                  {/* <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Quantity</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.quantity || 'N/A'}</p>
                  </div> */}
                  {/* <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Unit</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.unit || 'N/A'}</p>
                  </div> */}
                  <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Is Returnable</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.isReturnable == true ? "Yes" : "No"}</p>
                  </div>
                  {/* <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Status</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.status || '-'}</p>
                  </div>                 */}
                  {/* <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Approved By</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.approvedByName  ? capitalizeFirstLetter(data.approvedByName) : 'N/A'}</p>
                  </div> */}
                   <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Issueed By</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.issueedByName  ? capitalizeFirstLetter(data.issueedByName) : 'N/A'}</p>
                  </div>
                  {/* <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Prepared By</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.preparedByName  ? capitalizeFirstLetter(data.preparedByName) : 'N/A'}</p>
                  </div> */}
                  <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Reviewed By</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.reviewedByName  ? capitalizeFirstLetter(data.reviewedByName) : 'N/A'}</p>
                  </div>
          </div>
        </div>
        <div className="w-full bg-white  border border-gary  mt-2 rounded-lg ">
              <div className="w-full py-[1%] bg-baseColor-primary flex justify-between rounded-lg">
                {/* <p className=" w-[20%]  text-left text-white text-xs font-medium">
              {" "}
              Item Code
            </p> */}
                <p className="w-[5%]  text-center pl-2 text-white text-xs font-medium">
                  S.No{" "}
                </p>

                <p className=" w-[60%]   text-left text-white text-xs font-medium">
                  {" "}
                  Product{" "}
                </p>
                <p className=" w-[10%] text-center text-white text-xs font-medium">
                  {" "}
                  Unit
                </p>
                {/* <p className=" w-[20%] text-left text-white text-xs font-medium">  Category</p> */}
                <p className=" w-[15%] text-center  text-white text-xs font-medium">
                  {" "}
                  Quantity
                </p>
                <p className=" w-[15%] text-center  text-white text-xs font-medium">
                  {" "}
                  Return Quantity
                </p>
              </div>
              {/* {item.revProduct && item.revProduct((List[0], index) => { */}
              {/* {revData[0]?.revProduct && */}
                {data?.products?.map((List, index) => {
                  return (
                    <div
                      key={index}
                      className="w-full py-2 flex justify-between odd:bg-white even:bg-slate-100"
                    >
                      <p className="w-[5%]  text-center pl-2  text-xs font-medium text-[#111537] py-1">
                        {index + 1}
                      </p>
                      {/* <p className=" w-[20%] pl-1 text-left  text-xs font-medium text-[#111537] py-1">
                  {List?.item_code}
                </p> */}
                      <p className=" w-[60%]   text-left  text-xs font-medium text-[#111537] py-1">
                        {List?.product_name}
                      </p>
                      <p className=" w-[10%] text-center  text-xs font-medium text-[#111537] py-1">
                        {List?.unit}
                      </p>
                      {/* <p className=" w-[20%] text-left  text-xs font-medium text-[#111537] py-1">
                    {List?.product_category}
                  </p> */}

                      <p className=" w-[15%] text-center   text-xs font-medium text-[#111537] py-1">
                        {List?.quantity}
                      </p>
                      <p className=" w-[15%] text-center   text-xs font-medium text-[#111537] py-1">
                        {List?.returnedQty}
                      </p>
                    </div>
                  );
                })
                }
            </div>
      </div>
             
          
          <div className="md:w-[30%] mt-2 md:mt-0 h-full bg-white rounded-lg drop-shadow-lg py-2 ">
        <div className="h-[98%] overflow-y-scroll p-2 ">
<ApprovalComponent id={id} getUrl={getUrl} putUrl={putUrl} statusUrl={statusUrl} preUrlName={"requests"}/>
<div className="w-full grid  border border-gary mt-4  rounded-lg">
<div className="bg-baseColor-primary  p-2 rounded-t-lg">
            <p className="text-xs text-white font-medium">Request Detail</p>

            </div>
            <div className="w-full flex px-2 justify-between">
              <p className=" w-1/3 py-2 text-xs font-medium text-[#111537] ">
              Agent ID
              </p>
              <p className=" w-[65%] py-2 text-xs pl-5 text-[#606279] truncate">: {data?.requestId || '0'}
              </p>
            </div> 
            <div className="w-full flex px-2 justify-between">
              <p className=" w-1/3 py-2 text-xs font-medium text-[#111537]">
              Request For
              </p>
              <p className=" w-[65%] py-2 text-xs pl-5 text-[#606279] truncate">: {data?.requestFor || 'N/A'}
              </p>
            </div>
           
            <div className="w-full flex px-2 justify-between ">
  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
  Purpose
  </p>
  <p className=" w-[65%] py-2 text-xs pl-5 text-[#606279] truncate">: {data?.purpose || 'N/A'}
  </p>
</div>

            
         </div>
         </div>
         </div>
           </div>
              </div>
           
  
  )
};
export default ViewRequest;